import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Puzzle, MessageSquareWarning } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: <AlertTriangle className="w-5 h-5" data-id="element-13" />,
    title: 'Kit de Señales de Alerta por Edad',
    desc: 'Checklists listos para detectar desvíos del desarrollo en cada etapa evolutiva. Una herramienta que usás en cada consulta de control para no dejar pasar nada importante.'
  }, {
    icon: <Puzzle className="w-5 h-5" data-id="element-14" />,
    title: 'Banco de Actividades de Estimulación Temprana',
    desc: 'Colección de actividades listas para indicarle a los padres según la edad y el área de desarrollo a estimular. Ahorrás tiempo de planificación en cada consulta.'
  }, {
    icon: <MessageSquareWarning className="w-5 h-5" data-id="element-15" />,
    title: 'Guía de Comunicación Difícil con Padres',
    desc: 'El momento más tenso de la consulta pediátrica resuelto con una guía paso a paso. Cómo comunicar diagnósticos complejos, derivaciones urgentes y situaciones sensibles con claridad y empatía.'
  }];
  return <section id="bonos" className="py-8 bg-emerald-50" data-id="element-16">
      <div className="max-w-2xl mx-auto px-4 sm:px-6" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5" data-id="element-18">
          <p className="text-[10px] font-bold tracking-widest text-emerald-600 uppercase mb-1" data-id="element-19">
            🎁 GRATIS POR EL DÍA DE HOY
          </p>
          <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight" data-id="element-20">
            Bonos Exclusivos
          </h3>
        </motion.div>

        <div className="space-y-2.5 mb-5" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.3
        }} className="bg-white border border-emerald-200 rounded-xl px-4 py-3 flex gap-3 items-start shadow-sm" data-id="element-22">
              <div className="text-emerald-600 bg-emerald-100 border border-emerald-200 w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-23">
                {bonus.icon}
              </div>
              <div className="min-w-0" data-id="element-24">
                <h4 className="font-bold text-gray-900 text-sm mb-0.5" data-id="element-25">
                  {bonus.title}
                </h4>
                <p className="text-gray-600 text-xs leading-relaxed" data-id="element-26">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center pt-2" data-id="element-27">
          <p className="text-gray-500 text-xs mb-1" data-id="element-28">
            Valor total de los 3 bonos:{' '}
            <span className="line-through text-gray-400 font-medium" data-id="element-29">
              $48.000 ARS
            </span>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-1.5 text-base md:text-lg font-bold text-emerald-600" data-id="element-30">
            <span data-id="element-31">Por el día de hoy</span>
            <span className="font-normal" data-id="element-32">→</span>
            <span className="bg-emerald-100 text-emerald-700 px-3 py-0.5 rounded-full text-sm md:text-base" data-id="element-33">
              GRATIS
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}